import { defineComponent as _defineComponent } from 'vue'
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { OfferLocation } from '@/helpers/offer-helper';
import { getPromoText } from '@/helpers/provider-promotion';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';

import { computed } from 'vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { MonetizationType } from '@/@types/graphql-types';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProviderPromotionOffer',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail };



const { country } = useLanguageStore();

const promotion = computed(() => getPromoText(country.value, props.title.offers));

// we can be reasonably sure there is an offer because the parent would check
// nonetheless, there's an extra check in the template
const offer = computed(() =>
	props.title.offers.find(
		offer =>
			offer.monetizationType === MonetizationType.Flatrate &&
			offer.package.packageId === promotion.value?.provider
	)
);

const titleContext = computed(() => new SnowplowTitleContextGraphql(props.title.objectId, props.title.objectType));

const clickOutUrl = computed(
	() =>
		promotion.value?.url ??
		new ClickoutUrl(offer.value).addContexts(titleContext.value).set('uct_country', country.value).toString()
);

function handleClickout() {
	if (offer.value == null) return;

	TrackingHelper.trackEvent(
		'clickout',
		{
			action: offer.value.monetizationType.toLowerCase(),
			label: offer.value.package.clearName,
			property: offer.value.presentationType === '_4K' ? '4k' : offer.value.presentationType.toLowerCase(),
			value: OfferLocation.BACKDROP,
		},
		[titleContext.value]
	);
}

return { __sfc: true,props, country, promotion, offer, titleContext, clickOutUrl, handleClickout, ProviderIcon }
}

})